import React from 'react';
import PropTypes from 'prop-types';
import IconButton from 'material-ui/IconButton';
import SettingsIcon from 'material-ui/svg-icons/action/settings';
import CircularProgress from 'material-ui/CircularProgress';
import Item from '../item/Item';
import QueueDialog from './QueueDialog';
import OverlayController from '../overlay/OverlayController';
import { GraphQLStackTrace } from '../../utils/utils';
import queries from '../../graphql/queries';
import { compose } from 'react-apollo';
import './Queue.css'


class Queue extends React.Component {

    constructor(props) {
        super(props);

        this.queueItemListElm = null;
        this.loadingMoreElm = null;
        this.scrollHandlerAttached = false;
        this.fetchingMore = false;
        this.onScrollHandler = this.onScrollHandler.bind(this);
    }

    didClickSettingsButton() {
        OverlayController.showOverlay({
            component: <QueueDialog queue={this.props.queue} projectId={this.props.project.id} />
        });
    }

    componentDidMount() {
        this.loadMoreItemsIfNeeded();
    }

    componentWillUnmount() {
        if (this.scrollHandlerAttached) {
            this.scrollHandlerAttached = false;
            this.queueItemListElm.removeEventListener("scroll", this.onScrollHandler, false);
        }
    }

    componentDidUpdate() {
        this.loadMoreItemsIfNeeded();
    }

    onScrollHandler() {
        this.loadMoreItemsIfNeeded();
    }

    loadMoreItemsIfNeeded() {
        if (!this.queueItemListElm || !this.loadingMoreElm || !this.props.items.itemList.hasMore || this.fetchingMore) {
            if (this.scrollHandlerAttached) {
                this.scrollHandlerAttached = false;
                this.queueItemListElm.removeEventListener("scroll", this.onScrollHandler, false);
            }
            return;
        }

        if (!this.scrollHandlerAttached) {
            this.scrollHandlerAttached = true;
            this.queueItemListElm.addEventListener("scroll", this.onScrollHandler, false);
        }

        let scrollHeight = this.queueItemListElm.scrollHeight;
        let scrollTop = this.queueItemListElm.scrollTop;
        let clientHeight = this.queueItemListElm.clientHeight;
        let loadingMoreElmHeight = this.loadingMoreElm.offsetHeight;

        if (scrollHeight - scrollTop - clientHeight < loadingMoreElmHeight + 10) {
            this.fetchingMore = true;
            this.props.loadMoreItems().then(() => {
                this.fetchingMore = false;
                this.loadMoreItemsIfNeeded();
            });
        }
    }

    render() {
        let isCurrentUserAdmin = (this.props.queue.aclRole === "admin");
        let queueItemList = null;
        let numberOfItems = '...';

        if (this.props.items.loading) {
            queueItemList = <CircularProgress className="activityIndicator"/>;
        } else if (this.props.items.error) {
            queueItemList = <pre>{GraphQLStackTrace(this.props.items.error)}</pre>;
        } else {
            let listViewTemplate = this.props.queue.itemListViewTemplate || this.props.project.itemListViewTemplate;
            numberOfItems = this.props.items.itemList.total;
            queueItemList = (
                <ul className="queueItemList" ref={(elm) => this.queueItemListElm = elm}>
                    {this.props.items.itemList.items.map(item =>
                        <li key={item.id} className="queueItemListItem mdc-card">
                            <Item
                                projectId={this.props.project.id}
                                item={item}
                                queueItemViewButtons={this.props.queue.itemViewButtons}
                                listViewTemplate={listViewTemplate} />
                        </li>
                    )}
                    {this.props.items.itemList.hasMore &&
                        <li className="loadingMoreItems mdc-card" ref={(elm) => this.loadingMoreElm = elm}>loading more...</li>
                    }
                </ul>
            );
        }

        return (
            <div className="queue">
                {isCurrentUserAdmin &&
                    <div className="queueMenuIconWrapper" onClick={(event) => {event.stopPropagation()}} >
                        <IconButton className="queueSettingsButton" onTouchTap={this.didClickSettingsButton.bind(this)}>
                            <SettingsIcon className="queueSettingsIcon"/>
                        </IconButton>
                    </div>
                }
                <div className="queueName">{this.props.queue.name}</div>
                <div className="queueItemsCount">Number of items: {numberOfItems}</div>
                {queueItemList}
            </div>
        )
    }

}

Queue.propTypes = {
    project: PropTypes.object.isRequired,
    queue: PropTypes.object.isRequired,
    items: PropTypes.object.isRequired
};

export default compose(
    queries.itemListQueryHoc
)(Queue);



// WEBPACK FOOTER //
// ./src/components/queue/Queue.js